import * as ActionTypes from './actionTypes';
import extend from 'lodash/extend';

const defaultState = {
  lastSessionTime: '',
  show302RedirectionPopup: false,
  bpUserToken: '',
  // Below property is for simulation flow
  selectedUserId: '',
  // Below property is for delegate flow
  selectedTaxId: '',
  recentNotificationsData: {
    notifClientId: '',
  }
};

export default function headerReducers(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_TITLE:
    case ActionTypes.SET_LOGIN_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.REFRESH_LOGIN_SESSION:
      return setLatestTimeStamp(state, 'lastSessionTime');
    case ActionTypes.SESSION_EXPIRED_302:
      return setRedirectionPopup(state);
    case ActionTypes.SESSION_EXPIRED_302_RESET:
      return resetRedirectionPopup(state);
    case ActionTypes.SET_BP_USER_AUTH_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.SET_NOTIFICATIONS_CLIENTID:
        return {
          ...state,
          recentNotificationsData: {
            ...state.recentNotificationsData,
            notifClientId: action.data
          },
        };
    case ActionTypes.PASSWORDLESS_STATUS:
      return setPasswordlessOptInStatus(state, action);
    default:
      return state;
  }
}

const setLatestTimeStamp = (state, lastApiCallTime) => {
  const dt = new Date();
  return extend({}, state, { [lastApiCallTime]: dt });
};

const setRedirectionPopup = state => {
  return extend({}, state, { show302RedirectionPopup: true });
};

const resetRedirectionPopup = state => {
  return extend({}, state, { show302RedirectionPopup: false });
};

const setPasswordlessOptInStatus = (state, action) => {
  return extend({}, state, { hasUserOptedInForPasswordless: action.payload });
};